var tag = new ATInternet.Tracker.Tag({site: siteId});
tag.page.set(sitePageVars);
tag.customVars.set(siteCustomVars);

// Init ScrollTracking
tag.Scroll.init({});

// Tracking
tag.dispatch();

